import { useSyncExternalStore } from 'react';

// https://react.dev/reference/react/useSyncExternalStore#subscribing-to-a-browser-api

export function useNetworkConnectionStatus(): boolean {
  const isOnline = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );
  return isOnline;
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

function getServerSnapshot(): boolean {
  // Always show "Online" for server-rendered HTML
  return true;
}

function subscribe(callback: () => void): () => void {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}
